import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getBatches } from '../../services'
import { BatchesQueryKeys } from '@/modules/batches/keys'
import { GetBatchesResponse } from '@/modules/batches/type'
import { CouponType } from '@/schema'

export default function useQueryGetBatchesForBrokeNotification(
	props?: UseBaseQueryOptions<GetBatchesResponse>,
) {
	return useQuery({
		queryKey: [BatchesQueryKeys.GetBatchesForBrokeNotification],
		queryFn: () =>
			getBatches({
				take: 1000,
				skip: 0,
				isActive: true,
			}),
		select: (data) => ({
			...data,
			// Filter only SINGLE type batches
			data: data.data.filter((batch) => batch.type === CouponType.SINGLE),
		}),
		...props,
	})
}
